import { useSessionStore } from '../../state/persistentStore';

function useSesion() {
    const token = useSessionStore((state) => state.token);
    const start = useSessionStore((state) => state.start);
    const end = useSessionStore((state) => state.end);
    const user = useSessionStore((state) => state.user);
    const setUser = useSessionStore((state) => state.setUser);

    function startSesion(val) {
        start(val);
    };

    function endSesion (){
        end();
    };

    function isLogged() {
        return (token !== "");
    };

    function getToken() {
        return token;
    }

    function getCurrentUser() {
        return user;
    }

    function setCurrentUser(val) {
        return setUser(val);
    }

    return { startSesion, endSesion, isLogged, getToken, setCurrentUser, getCurrentUser };
}

export default useSesion;